import { createAsyncThunk } from '@reduxjs/toolkit';
import { getApi } from 'redux/apis';
import { showNotification } from 'utils/notification';

interface GetClosingDateParams {
	syncLogs?: boolean;
}

export const fetchClosingDateAction = createAsyncThunk(
	'closingDate/get',
	async (params: GetClosingDateParams = {}, { rejectWithValue }) => {
		try {
			const response = await getApi(`/quickbooks/closingDate`, {
				companyId: localStorage.getItem('companyId'),
				...params,
			});
			return response.data;
		} catch (error: any) {
			if (
				error?.response?.data?.message ===
				'QuickBooks session expired. Please reconnect your company to continue.'
			) {
				showNotification({
					type: 'error',
					message: 'Session Expired',
					description: error.response.data.message,
				});
			}

			return rejectWithValue(error?.response?.data);
		}
	}
);
